module.exports = __webpack_public_path__ + "icon-intern.2HeESLEq.svg";